import { orderDayFullCollection } from "@/firebase";
import { orderMonthFullCollection } from "@/firebase";

const state = {
  orderDayFull: [],
  orderStatsMonthSum: {},
  orderStats: [],
};

const getters = {};

const actions = {
  getOrderLast7Days({ commit }, payload) {
    return new Promise((resolve, reject) => {
      let fromDate = (d => new Date(d.setDate(d.getDate() - 7)))(new Date());
      let toDate = new Date(Date.now());

      orderDayFullCollection
        .where("client", "==", payload.client)
        .where("date", ">=", fromDate)
        .where("date", "<=", toDate)
        .orderBy("date", "asc")
        .get()
        .then(querySnapshot => {
          if (querySnapshot.empty) {
            commit("getOrderLast7Days", {});
            resolve();
          } else {
            let tempData = [];
            querySnapshot.forEach(doc => {
              tempData.push(doc.data().totalSumCart);
            });
            commit("getOrderLast7Days", tempData);
            resolve();
          }
        })
        .catch(error => {
          console.log(error);
          reject();
        });
    });
  },
  getOrderFullMonthDays({ commit }, payload) {
    return new Promise((resolve, reject) => {
      orderDayFullCollection
        .where("client", "==", payload.client)
        .where("date", ">=", payload.from)
        .where("date", "<=", payload.to)
        .orderBy("date", "asc")
        .get()
        .then(querySnapshot => {
          if (querySnapshot.empty) {
            commit("getOrderFullMonthDays", [{ data: [] }]);
            resolve();
          } else {
            let tempData = [];
            let tempData2 = [];
            let tempData3 = [];
            let totalCopiesSum = 0;
            let itemCopiesSum = 0;
            let extraCostsSum = 0;
            let totalSumCart = 0;
            let itemCopies = 0;
            let orderNum = 0;
            let orderNumCompany = 0;
            let orderNumPaymentCard = 0;
            let orderNumPaymentDelivery = 0;
            let orderNumPaymentPersonal = 0;
            let orderNumPaymentPrepay = 0;
            let orderNumPost = 0;
            let orderNumPromoCode = 0;
            let totalCopies = 0;

            querySnapshot.forEach(doc => {
              // za izračun mesečnega povzetka statistike              
              itemCopies += doc.data().itemCopies > 0 ? doc.data().itemCopies : 0;
              orderNum += doc.data().orderNum > 0 ? doc.data().orderNum : 0;
              orderNumCompany += doc.data().orderNumCompany > 0 ? doc.data().orderNumCompany : 0;
              orderNumPaymentCard += doc.data().orderNumPaymentCard > 0 ? doc.data().orderNumPaymentCard : 0;
              orderNumPaymentDelivery += doc.data().orderNumPaymentDelivery > 0 ? doc.data().orderNumPaymentDelivery : 0;
              orderNumPaymentPersonal += doc.data().orderNumPaymentPersonal > 0 ? doc.data().orderNumPaymentPersonal : 0;
              orderNumPaymentPrepay += doc.data().orderNumPaymentPrepay > 0 ? doc.data().orderNumPaymentPrepay : 0;
              orderNumPost += doc.data().orderNumPost > 0 ? doc.data().orderNumPost : 0;
              orderNumPromoCode += doc.data().orderNumPromoCode > 0 ? doc.data().orderNumPromoCode : 0;
              totalCopies += doc.data().totalCopies > 0 ? doc.data().totalCopies : 0;
              totalCopiesSum += parseFloat(doc.data().totalCopiesSum.toFixed(payload.digits));
              itemCopiesSum += parseFloat(doc.data().itemCopiesSum.toFixed(payload.digits));
              extraCostsSum += parseFloat(doc.data().totalSumCart.toFixed(payload.digits)) - parseFloat(doc.data().totalSumCartNoExtra.toFixed(payload.digits));
              totalSumCart += parseFloat(doc.data().totalSumCart.toFixed(payload.digits));
              //console.log(totalCopiesSum, itemCopiesSum, extraCostsSum, totalSumCart);

              tempData.push({ x: doc.data().date.toDate(), y: doc.data().totalCopiesSum.toFixed(payload.digits) });
              tempData2.push({ x: doc.data().date.toDate(), y: doc.data().itemCopiesSum.toFixed(payload.digits) });
              tempData3.push({ x: doc.data().date.toDate(), y: (doc.data().totalSumCart - doc.data().totalSumCartNoExtra).toFixed(payload.digits) });
            });
            commit("getOrderFullMonthDays", [{ name: payload.labelImageOrder, data: tempData }, { name: payload.labelGiftOrder, data: tempData2 }, { name: payload.labelExtraCosts, data: tempData3 }]);
            commit("setMonthlySum", {
              itemCopies: itemCopies,
              orderNum: orderNum,
              orderNumCompany: orderNumCompany,
              orderNumPaymentCard: orderNumPaymentCard,
              orderNumPaymentDelivery: orderNumPaymentDelivery,
              orderNumPaymentPersonal: orderNumPaymentPersonal,
              orderNumPaymentPrepay: orderNumPaymentPrepay,
              orderNumPost: orderNumPost,
              orderNumPromoCode: orderNumPromoCode,
              totalCopies: totalCopies,
              totalCopiesSum: Math.round(totalCopiesSum),
              itemCopiesSum: Math.round(itemCopiesSum),
              extraCostsSum: Math.round(extraCostsSum),
              totalSumCart: Math.round(totalSumCart)
            });
            resolve();
          }
        })
        .catch(error => {
          console.log(error);
          reject();
        });
    });
  },
  getOrderFullYearMonths({ commit }, payload) {
    return new Promise((resolve, reject) => {
      orderMonthFullCollection
        .where("client", "==", payload.client)
        .where("date", ">=", payload.from)
        .where("date", "<=", payload.to)
        .orderBy("date", "asc")
        .get()
        .then(querySnapshot => {
          if (querySnapshot.empty) {
            commit("getOrderFullMonthDays", [{ data: [] }]);
            resolve();
          } else {
            let tempData = [];
            let tempData2 = [];
            let tempData3 = [];
            let totalCopiesSum = 0;
            let itemCopiesSum = 0;
            let extraCostsSum = 0;
            let totalSumCart = 0;
            let itemCopies = 0;
            let orderNum = 0;
            let orderNumCompany = 0;
            let orderNumPaymentCard = 0;
            let orderNumPaymentDelivery = 0;
            let orderNumPaymentPersonal = 0;
            let orderNumPaymentPrepay = 0;
            let orderNumPost = 0;
            let orderNumPromoCode = 0;
            let totalCopies = 0;

            querySnapshot.forEach(doc => {
              // za izračun mesečnega povzetka statistike              
              itemCopies += doc.data().itemCopies > 0 ? doc.data().itemCopies : 0;
              orderNum += doc.data().orderNum > 0 ? doc.data().orderNum : 0;
              orderNumCompany += doc.data().orderNumCompany > 0 ? doc.data().orderNumCompany : 0;
              orderNumPaymentCard += doc.data().orderNumPaymentCard > 0 ? doc.data().orderNumPaymentCard : 0;
              orderNumPaymentDelivery += doc.data().orderNumPaymentDelivery > 0 ? doc.data().orderNumPaymentDelivery : 0;
              orderNumPaymentPersonal += doc.data().orderNumPaymentPersonal > 0 ? doc.data().orderNumPaymentPersonal : 0;
              orderNumPaymentPrepay += doc.data().orderNumPaymentPrepay > 0 ? doc.data().orderNumPaymentPrepay : 0;
              orderNumPost += doc.data().orderNumPost > 0 ? doc.data().orderNumPost : 0;
              orderNumPromoCode += doc.data().orderNumPromoCode > 0 ? doc.data().orderNumPromoCode : 0;
              totalCopies += doc.data().totalCopies > 0 ? doc.data().totalCopies : 0;
              totalCopiesSum += parseFloat(doc.data().totalCopiesSum.toFixed(payload.digits));
              itemCopiesSum += parseFloat(doc.data().itemCopiesSum.toFixed(payload.digits));
              extraCostsSum += parseFloat(doc.data().totalSumCart.toFixed(payload.digits)) - parseFloat(doc.data().totalSumCartNoExtra.toFixed(payload.digits));
              totalSumCart += parseFloat(doc.data().totalSumCart.toFixed(payload.digits));

              tempData.push({ x: doc.data().date.toDate(), y: doc.data().totalCopiesSum.toFixed(payload.digits) });
              tempData2.push({ x: doc.data().date.toDate(), y: doc.data().itemCopiesSum.toFixed(payload.digits) });
              tempData3.push({ x: doc.data().date.toDate(), y: (doc.data().totalSumCart - doc.data().totalSumCartNoExtra).toFixed(payload.digits) });
            });
            commit("getOrderFullMonthDays", [{ name: payload.labelImageOrder, data: tempData }, { name: payload.labelGiftOrder, data: tempData2 }, { name: payload.labelExtraCosts, data: tempData3 }]);
            commit("setMonthlySum", {
              itemCopies: itemCopies,
              orderNum: orderNum,
              orderNumCompany: orderNumCompany,
              orderNumPaymentCard: orderNumPaymentCard,
              orderNumPaymentDelivery: orderNumPaymentDelivery,
              orderNumPaymentPersonal: orderNumPaymentPersonal,
              orderNumPaymentPrepay: orderNumPaymentPrepay,
              orderNumPost: orderNumPost,
              orderNumPromoCode: orderNumPromoCode,
              totalCopies: totalCopies,
              totalCopiesSum: Math.round(totalCopiesSum),
              itemCopiesSum: Math.round(itemCopiesSum),
              extraCostsSum: Math.round(extraCostsSum),
              totalSumCart: Math.round(totalSumCart)
            });
            resolve();
          }
        })
        .catch(error => {
          console.log(error);
          reject();
        });
    });
  }
};

const mutations = {
  getOrderLast7Days(state, payload) {
    state.orderDayFull = payload;
    //console.log(state.orderDayFull);
  },
  getOrderFullMonthDays(state, payload) {
    state.orderStats = payload;
    //console.log(state.orderStats);
  },
  setMonthlySum(state, payload) {
    state.orderStatsMonthSum = payload;
    //console.log(state.orderStatsMonthSum);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
